export const PENALTY_LEVEL_NONE = 0;         
export const PENALTY_LEVEL_CAPTCHA = 1;     
export const PENALTY_LEVEL_RESTRICTED = 2;  
export const PENALTY_LEVEL_BLOCKED = 3;  
